import api from "../axiosIntercepture";

/**
 * Create shipment
 * POST -> shipment/create
 * Returns created shipment data on success, otherwise throws Error with message from backend (or friendly fallback).
 */
export const createShipment = async (payload) => {
    try {
        const response = await api.post("shipment/create", payload);

        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }

        const message = response.data?.message || "Failed to create shipment";
        throw new Error(message);
    } catch (err) {
        console.error("Error creating shipment:", err);

        let errorMessage = "Failed to create shipment";
        if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
        } else if (err.message) {
            errorMessage = err.message;
        }

        // Small helpful hint for common problems (adjust text to your team's terminology)
        const lower = errorMessage.toLowerCase();
        if (lower.includes("asn")) {
            errorMessage = `${errorMessage} — please ensure the ASN reference included in the payload is valid.`;
        } else if (lower.includes("awb")) {
            errorMessage = `${errorMessage} — please verify AWB / carrier details in the payload.`;
        }

        throw new Error(errorMessage);
    }
};

/**
 * Fetch shipments
 * POST -> shipment/fetch
 * Returns an array (empty array if backend returns no data).
 * Accepts filters object.
 */
export const fetchShipment = async (page, pageSize, filters = {}) => {
    try {

        const sendObj = {
            filters: filters,
            limit: pageSize,
            page: page + 1
        };

        const response = await api.post(`shipment/fetch-multi-dynamic`, sendObj);

        if (!response.data?.success) {
            const msg = response.data?.message || "Failed to fetch shipments";
            throw new Error(msg);
        }

        // Always return an array to simplify UI code
        return Array.isArray(response.data?.data?.data) ? response.data.data : [];
    } catch (err) {
        console.error("Error fetching shipments:", err);
        throw new Error(err?.response?.data?.message || "Failed to fetch shipments");
    }
};

/**
 * Get shipment by id
 * POST -> shipment/get
 * Returns shipment object or null if not found.
 */
// export const getShipmentById = async (id) => {
//     try {
//         const response = await api.post("shipment/get", { id });

//         if (response.data?.success && response.data?.data) {
//             return response.data.data;
//         }
//         return null;
//     } catch (err) {
//         console.error("Error fetching shipment by id:", err);
//         throw new Error(err?.response?.data?.message || "Failed to fetch shipment");
//     }
// };



// updated to call GET /shipment/fetch-list?id=...
export const getShipmentById = async (id) => {
    try {
        // use axios params so it becomes: GET /shipment/fetch-list?id=...
        const response = await api.post(`shipment/fetch-list?id=${id}`);

        // assume API returns { success: true, data: ... }
        const respData = response?.data;

        if (respData?.success && respData?.data != null) {
            const payload = respData.data;

            // If API returns an array (fetch-list), return the first record.
            if (Array.isArray(payload)) {
                return payload.length ? payload[0] : null;
            }

            // Otherwise return the object directly
            return payload;
        }

        return null;
    } catch (err) {
        console.error("Error fetching shipment by id:", err);
        // preserve original server message when available
        const serverMsg = err?.response?.data?.message;
        throw new Error(serverMsg || "Failed to fetch shipment");
    }
};


// src/services/shipment/shipment.js

export const updateShipment = async (shipmentIdOrNumber, payload) => {
    if (!shipmentIdOrNumber) throw new Error("Missing identifier for updateShipment");

    try {
        const encoded = encodeURIComponent(shipmentIdOrNumber);
        const response = await api.post(`shipment/update/${encoded}`, payload);

        // adapt depending on your API shape (success/data vs data)
        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }
        if (response.data) {
            return response.data;
        }

        return response;
    } catch (err) {
        console.error("Error updating shipment:", err);

        let errorMessage = "Failed to update shipment";
        if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
        } else if (err.message) {
            errorMessage = err.message;
        }

        // add some helpful guidance if message looks like known failure
        if (errorMessage.toLowerCase().includes("shipment")) {
            errorMessage = `${errorMessage}`;
        }

        throw new Error(errorMessage);
    }
};




export default {
    createShipment,
    fetchShipment,
    getShipmentById,
    updateShipment
};
